import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import AmbassadorComponent from "@/components/Ambassador";
import { imageResize } from '@distancify/drapejs-storyblok';


export default /*#__PURE__*/_defineComponent({
  __name: 'Ambassador',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const mainImage = computed(() => imageResize(props.block?.mainImage, { height: 700 })?.filename);
const profileImage = computed(() => imageResize(props.block?.profileImage, { height: 150 })?.filename);
const textContent = computed(() =>props.block?.textContent?.[0]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AmbassadorComponent), {
    main: _unref(mainImage),
    profile: _unref(profileImage),
    text: _unref(textContent)
  }, null, 8, ["main", "profile", "text"]))
}
}

})